<h4 class="re-container-with-margin re-mb-20 md:re-mb-30">
  {{ 'personaldata.personal.title' | translate }}
</h4>

@if (state === LoadingState.ERROR) {
  <bdo-info-box class="bdo-container--single">
    {{ 'general.error.error' | translate }}
  </bdo-info-box>
}

<div class="re-bg-white re-w-full re-px-30 re-py-20 re-text re-mb-3
            md:re-w-600 md:re-mx-auto
            lg:re-w-900">
  <div class="re-inline">{{ 'general.customerData.account' | translate }}</div>
  <div class="re-inline bold">{{accountId}}</div>
</div>

<form (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()" [formGroup]="form" bdoScrollToInvalidControl [attr.aria-label]="'aria.form.personalData' | translate">
  <bdo-edit-card
    [isEditable]="state !== LoadingState.LOADING && !isInEditMode"
    [disabled]="disabled"
    (edit)="changeEditMode()">

    <div class="re-relative">
      @if (state === LoadingState.LOADING) {
        <bdo-loading></bdo-loading>
      }

      <!-- show fields independently -->
      <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
        <div>{{ 'address.salutation.title' | translate }}</div>
        <div data-qa="titleValue">{{personalData?.titleValue}}</div>
      </div>

      <div [ngClass]="{'re-mb-45': personalData?.person2?.firstname || isGewe}">
        <!-- Partnerkind: PRIV -->
        @if (!isGewe) {
          <div>
            <!-- Person 1 -->
            <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
              <div>{{ 'address.personalInfo.name' | translate }}</div>
              <div data-qa="person1-name">{{personalData?.person1?.firstname}} {{personalData?.person1?.lastname}}</div>
            </div>
            @if (personalData?.person1?.birthdate) {
              <div>
                <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
                  <div>{{ 'address.personalInfo.birthdate.title' | translate }}</div>
                  <div data-qa="person1-dateOfBirth">{{personalData.person1.birthdate | date}}</div>
                </div>
              </div>
            }
            <!-- Person 2 -->
            @if (personalData?.person2?.firstname) {
              <div>
                <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
                  <div>{{ 'address.personalInfo.name' | translate }}</div>
                  <div data-qa="person2-name">{{personalData.person2.firstname}} {{personalData?.person2?.lastname}}</div>
                </div>
                @if (personalData?.person2?.birthdate) {
                  <div>
                    <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
                      <div>{{ 'address.personalInfo.birthdate.title' | translate }}</div>
                      <div data-qa="person2-dateOfBirth">{{personalData.person2.birthdate | date}}</div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Partnerkind: GEWE -->
        @if (isGewe) {
          <div>
            <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
              <div>{{ 'address.personalInfo.name1' | translate }}</div>
              <div data-qa="org-name1">{{personalData?.org?.nameOrg1}}</div>
            </div>
            <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
              <div>{{ 'address.personalInfo.name2' | translate }}</div>
              <div data-qa="org-name2">{{personalData?.org?.nameOrg2}}</div>
            </div>
            <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
              <div>{{ 'address.business.sector.title' | translate }}</div>
              <div data-qa="org-sectorId">{{sectorDisplayText}}</div>
            </div>
            <div [ngClass]="{'re-summary-row': !isInEditMode, 're-form-item-container-row' : isInEditMode}">
              <div>{{ 'address.business.legalEntity.title' | translate}}</div>
              <div data-qa="org-legalEntityId">{{legalDisplayText}}</div>
            </div>
          </div>
        }

      </div>

      <!-- show changeable fields statically  -->
      @if (!isInEditMode) {
        <div>
          <div class="re-summary-row">
            <div>{{ 'address.phonenumber.title' | translate }}</div>
            <div data-qa="phonenumber">{{showPhonenumber}}</div>
          </div>
          @if (personalData?.mobilenumber && personalData?.phonenumber) {
            <div>
              <div class="re-summary-row">
                <div>{{ 'address.phonenumber.mobileNumber' | translate }}</div>
                <div data-qa="mobilenumber">{{personalData.mobilenumber.number}}</div>
              </div>
            </div>
          }
          <div class="re-summary-row re-mb-0">
            <div>{{ 'address.email.title' | translate }}</div>
            <div data-qa="email" [innerText]="personalData?.email?.smtpAddress ? personalData.email.smtpAddress : '-'"></div>
          </div>
          @if (state !== LoadingState.LOADING && tmpEmail) {
            <bdo-info-box
              class="re-block re-mt-25"
              [type]="'info'">
              <div [innerHTML]="'address.emailVerification.hint' | translate : {email:tmpEmail}"></div>
              <!-- Resending the verification is temporarily hidden: it would trigger an email change, which the backend currently rejects with NOT_IMPLEMENTED -->
            </bdo-info-box>
          }
        </div>
      }

      <!-- show changeable fields with input fields -->
      @if (isInEditMode) {
        <div>
          <fieldset name="contact-information" class="re-mb-0" [attr.aria-label]="'aria.fieldset.personalDataContact' | translate">
            @if (form.get('phonenumber')) {
              <div>
                <div class="re-form-item-container" data-qa="input-phonenumber">
                  <bdo-input
                    [id]="'phonenumber'"
                    [formControl]="$any(form.get('phonenumber'))"
                    [placeholder]="'address.phonenumber.title' | translate"
                  ></bdo-input>
                </div>
              </div>
            }
            @if (form.get('mobilenumber')) {
              <div>
                <div class="re-form-item-container" data-qa="input-mobilenumber">
                  <bdo-input
                    [id]="'mobilenumber'"
                    [formControl]="$any(form.get('mobilenumber'))"
                    [placeholder]="(form.get('phonenumber') ? 'address.phonenumber.mobileNumber' : 'address.phonenumber.title') | translate"
                  ></bdo-input>
                </div>
              </div>
            }
            <!-- Changing the email address is temporarily disabled, show the address instead -->
            <div class="re-form-item-container-row re-mb-0">
              <div>{{ 'address.email.title' | translate }}</div>
              <div data-qa="email" [innerText]="personalData?.email?.smtpAddress ? personalData.email.smtpAddress : '-'"></div>
            </div>
          </fieldset>
          <div class="re-form-item-container bdo-space--bottom re-mt-25 re-mb-15">
            <button class="bdo-button-primary bdo-button--text" data-qa="submit" type="submit">
              {{ 'general.action.save' | translate }}
            </button>
          </div>
          <div class="re-form-item-container re-mb-0">
            <button class="bdo-nolink" (click)="changeEditMode()">
              <div class="bold">{{ 'general.action.cancel' | translate }}</div>
            </button>
          </div>
        </div>
      }
    </div>
  </bdo-edit-card>
</form>
